module.exports = __webpack_public_path__ + "static/img/img-home-co-08.fa2e622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-08.png
// module id = Iv8w
// module chunks = 1